"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const deregistrationReasonEnums_1 = require("../../enums/deregistrationReasonEnums");
const getContentType_1 = require("../../helpers/getContentType");
const getState_1 = require("../../helpers/getState");
const command_1 = require("../../type/command");
const entity_1 = require("../../type/entity");
const applyUnregisterILTSessionCommand_1 = require("../applyUnregisterILTSessionCommand");
const applyUnregisterILTSessionsCommand_1 = require("../applyUnregisterILTSessionsCommand");
const updateEventAttributeFields_1 = require("../helpers/updateEventAttributeFields");
const deAssignContent_1 = require("./deAssignContent");
function deassignCurriculumChildContents(command, childContentIds, contents, user, states, enrolments) {
    const childContents = [];
    const events = [];
    let updatedEnrolments = enrolments;
    let updatedStates = states;
    const childrenContentsById = keyBy_1.default(contents, '_id');
    childContentIds.forEach((curriculumChildContentId) => {
        const content = childrenContentsById[curriculumChildContentId];
        const applyPayload = applyDeassignContent(command, user, content, childContents, states, updatedEnrolments);
        updatedEnrolments = applyPayload.enrolments;
        updatedStates = applyPayload.states;
        events.push(...applyPayload.events);
    });
    return { events, enrolments: updatedEnrolments, states: updatedStates };
}
function applyDeassignContent(command, user, content, childrenContents, states, enrolments) {
    try {
        const { id, creatorId, timeStamp } = command;
        const contentType = getContentType_1.getContentType(content);
        let events = [];
        const updatedStates = immer_1.default(states, draftStates => {
            let deassignPayload;
            switch (contentType) {
                case entity_1.ContentType.ILT:
                    const iltState = getState_1.getStateByContentIdUserId(draftStates, content._id, command.userId);
                    const sessionStates = draftStates.filter(draftState => draftState.contentType === entity_1.ContentType.ILT_SESSION);
                    const nonCompletedSessionStates = sessionStates.filter(sessionState => sessionState.completionStatus !== entity_1.CompletionStatus.COMPLETE);
                    const sessionIds = nonCompletedSessionStates.map(sessionState => sessionState.contentId);
                    let unregisterSessionPayload;
                    if (iltState.completionStatus !== entity_1.CompletionStatus.COMPLETE) {
                        // if ILT is of single register type so call apply single unregister command
                        if (!content.registrationType || content.registrationType === 'single') {
                            sessionIds.forEach(sessionId => {
                                const unregisterSessionCommand = {
                                    id,
                                    type: command_1.CommandType.UNREGISTER_SESSION,
                                    creatorId,
                                    contentId: content._id,
                                    sessionId,
                                    timeStamp,
                                    deregistrationReason: deregistrationReasonEnums_1.deregistrationReasonEnums.ADMIN_ILT_DEASSIGNED
                                };
                                unregisterSessionPayload = applyUnregisterILTSessionCommand_1.applyUnregisterILTSessionCommand(unregisterSessionCommand, user, content, states);
                                updateEventAttributeFields_1.updateEventAttributeFields(unregisterSessionPayload.events, { toSendMail: false });
                            });
                        }
                        else {
                            const unregisterSessionsCommand = {
                                id,
                                type: command_1.CommandType.UNREGISTER_SESSIONS,
                                creatorId,
                                contentId: content._id,
                                sessionIds,
                                timeStamp,
                                deregistrationReason: deregistrationReasonEnums_1.deregistrationReasonEnums.ADMIN_ILT_DEASSIGNED
                            };
                            unregisterSessionPayload = applyUnregisterILTSessionsCommand_1.applyUnregisterILTSessionsCommand(unregisterSessionsCommand, user, states);
                            updateEventAttributeFields_1.updateEventAttributeFields(unregisterSessionPayload.events, { toSendMail: false });
                        }
                    }
                    if (unregisterSessionPayload) {
                        events = events.concat(unregisterSessionPayload.events);
                        draftStates = unregisterSessionPayload.states;
                    }
                    iltState.updatedAt = command.timeStamp;
                    // mark all the states to be deleted
                    iltState.deleted = true;
                    iltState.deletedOn = timeStamp;
                    nonCompletedSessionStates.forEach(sessionState => {
                        sessionState.deleted = true;
                        sessionState.deletedOn = timeStamp;
                    });
                    // Deassigning ILT
                    deassignPayload = deAssignContent_1.deassignContent(command, user, content, draftStates, enrolments);
                    enrolments = deassignPayload.enrolments;
                    events.push(...deassignPayload.events);
                    break;
                case entity_1.ContentType.COURSE:
                case entity_1.ContentType.CHECKPOINT:
                    deassignPayload = deAssignContent_1.deassignContent(command, user, content, draftStates, enrolments);
                    enrolments = deassignPayload.enrolments;
                    events.push(...deassignPayload.events);
                    break;
                case entity_1.ContentType.CURRICULUM: {
                    const curriculumChildContentIds = content.offers.map((offer) => offer.offerId);
                    const childAssignPayload = deassignCurriculumChildContents(command, curriculumChildContentIds, childrenContents, user, draftStates, enrolments);
                    enrolments = childAssignPayload.enrolments;
                    events.push(...childAssignPayload.events);
                    const applyCurriculumPayload = deAssignContent_1.deassignContent(command, user, content, draftStates, enrolments);
                    enrolments = applyCurriculumPayload.enrolments;
                    events.push(...applyCurriculumPayload.events);
                    break;
                }
                default:
                    break;
            }
        });
        return {
            states: updatedStates,
            enrolments,
            events
        };
    }
    catch (error) {
        throw new Error('Error in apply deassignContent ' + error);
    }
}
exports.applyDeassignContent = applyDeassignContent;
//# sourceMappingURL=index.js.map